"use strict";
const DEBUG_KEY = "debug:v3routing";
function isTruthy(val) {
  if (!val) return false;
  const v = val.toLowerCase();
  return v === "1" || v === "true" || v === "yes" || v === "on";
}
export function isRoutingDebug() {
  try {
    if (typeof window !== "undefined" && window?.localStorage) {
      const flag = window.localStorage.getItem(DEBUG_KEY);
      if (flag !== null) return isTruthy(flag);
    }
  } catch {
  }
  return typeof process !== "undefined" ? process.env.NODE_ENV !== "production" : true;
}
export function routingLog(message, data) {
  if (!isRoutingDebug()) return;
  if (data === void 0) console.log(`[V3Routing] ${message}`);
  else console.log(`[V3Routing] ${message}`, data);
}
export function routingWarn(message, data) {
  if (!isRoutingDebug()) return;
  if (data === void 0) console.warn(`[V3Routing] ${message}`);
  else console.warn(`[V3Routing] ${message}`, data);
}
export function routingError(message, data) {
  if (!isRoutingDebug()) return;
  if (data === void 0) console.error(`[V3Routing] ${message}`);
  else console.error(`[V3Routing] ${message}`, data);
}
export const V3_ROUTING_DEBUG_KEY = DEBUG_KEY;
